import React, { useEffect, useState } from 'react';
import { Box, Button, Group } from '@mantine/core';
import axios from 'axios';
import ApiLinks from '../../Navlinks/ApiLinks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomMantineTable from '../../Utilities/CustomMantineTable';
import { DeleteRecords, EditRecord } from '../../Utilities/EditorDeleteRecords';


function Amenties() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);


  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/${ApiLinks.Amenties}/${user.compcode}`)
      .then((response) => {
        if (response.data.status) {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });

  }, [user.compcode]);



  const columns = [
    {
      id: 'actions',
      header: 'Actions',
      size: '100',
      Cell: ({ row }) => (
        <Group spacing="xs">
          <EditRecord
            id={row.original.id}
            route="/dashboard/ammetitesadd"
          />
          <DeleteRecords
            id={row.original.id}
            endpoint={`${ApiLinks.Amenties_Delete}`}
            compcode={user.compcode}
            onDeleteSuccess={(deletedId) =>
              setData((prev) => prev.filter((item) => item.id !== deletedId))
            }
          />
        </Group>
      ),
    },
    {
      accessorKey: 'amenitiesname',
      header: 'Amenity Name',
    },
    {
      accessorKey: 'photo',
      header: 'Photo',
      Cell: ({ cell }) => {
        const photoPath = cell.getValue();
        const imageUrl = `${process.env.REACT_APP_IMG_URL}/${photoPath}`;
        return (
          <a href={imageUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={imageUrl}
              alt="Amenity"
              style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
            />
          </a>
        );
      },
    },



  ];

  return (
    <Box>
      <Group position="apart" mb="md">
        <h2>Amenities List</h2>
        <Button onClick={() => navigate('/dashboard/ammetitesadd', { state: { id: null } })}>
          Create
        </Button>
      </Group>

      <CustomMantineTable columns={columns} data={data} loading={loading} />


    </Box>

  );
}

export default Amenties;
